<template>
    <div class="card" v-if="verificaTipoPeca">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-lg-2 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2">Problema:</div>
            <strong>{{ os.ds_conjunto }}</strong>
          </div>
          <div class="col-12 col-lg-8 text-left ">
            <div class="d-inline d-lg-block mr-2">{{ descricaoTipo }}:</div>
            <strong>{{ descricaoItem }}</strong>
          </div>

          <div class="col-12 col-lg-2 col-xl-2 text-left  mt-md-4 mt-lg-0">
            <div class="row">
              <div class="col-12 d-md-block d-lg-none mb-2">Ações</div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="descricaoTipo === 'PEÇAS'">
                <div class="m-2">
                  <label for="label-quantidade">Quantidade: </label>
                  <input type="number" id="label-quantidade" class="form-control"
                    :disabled="disabledPeca || item.item_atendido" v-model="quantidadeConvertida">
                </div>
                <button :disabled="disabledPeca || item.item_atendido" class="btn btn-success btn-block mb-2"
                  @click="registrarPeca()">
                  Registrar Peça <i v-if="disabledPeca || item.item_atendido" class="fa fa-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    item: {},
    os: {},
    disabled: { type: Boolean, default: false },
    initAt: {}
  },
  data() {
    return {
      cod_item: '',
      disabledPeca: '',
      quantidade: 0,
    }
  },
  computed: {
    itemAtendido() {
      if (this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R') {
        return this.item.item_atendido
      }

      return false
    },
    descricaoTipo() {
      if (this.item && this.item.item && this.item.item.tipo) {
        return this.item.item.tipo.ds_tipoitem
      }

      return ''
    },
    descricaoItem() {
      var descricao = ''

      if (this.descricaoTipo.length) {
        descricao = this.descricaoTipo + ' | '
      }

      if (this.item.item) {
        descricao += this.item.item.ds_item
      }

      if (!this.isExecutavel && this.item.estoque) {
        descricao += ` — ${this.item.estoque.ds_codigoitem}`
      }

      return descricao
    },
    quantidadeConvertida(){
      return parseFloat(this.item.qt_quantidade)
    },
    verificaTipoPeca() {
      try {
        if(this.item.item.tipo.nr_sequencial == 4) {
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    }

    

  },
  created() {
    this.quantidade = parseFloat(this.item.qt_quantidade)
    
  },
  methods: {
    registrarPeca() {
      this.disabledPeca = true
      
      const data = {
        nr_os: this.$route.params.id,
        nr_sequencial: this.item.nr_sequencial,
        quantidade: document.getElementById('label-quantidade').value
      }

      this.$store
        .dispatch('osItem/updatePeca', { data: data }).then(response => {
          this.disabledPeca = true
          // this.$swal.fire({
          //   title: 'Sucesso',
          //   text: 'Item registrado com sucesso!',
          //   icon: 'success'
          // })
        })
        .catch(error => {
          console.log(error)
          this.$swal.fire({
            title: 'Oops!',
            text: 'Falha ao registrar o item. Tente novamente.',
            icon: 'error'
          })
        })
    },

    reloadOS() {
      return this.$store.dispatch('os/getDetails', {
        nrSequencial: this.$route.params.id
      })
    }
  }
}
</script>